// PHASE 11C-1 - dedicated native-chat build-time feature flag, additional
// to (never a replacement for) the existing REACT_APP_NATIVE_BOTTOM_NAV_SHELL
// flag (see NativeShellController.js's own doc comment for that
// established convention - this file follows the exact same pattern:
// read once from process.env, exported as a boolean, default OFF unless
// its exact value is the string "true").
//
// Native chat is eligible ONLY when BOTH flags are "true" - the global
// native shell must already be enabled for native chat to ever activate
// (a chat-only flag with the shell disabled must still render the web
// ChatRoomPage fallback, matching the required flag matrix exactly).
//
// Neither flag is ever set to "true" in package.json, npm scripts, or any
// checked-in environment file - both remain build-time opt-in only.

const NATIVE_CHAT_FLAG_ENABLED = process.env.REACT_APP_NATIVE_CHAT === "true";
const NATIVE_SHELL_FLAG_ENABLED = process.env.REACT_APP_NATIVE_BOTTOM_NAV_SHELL === "true";

/**
 * @returns {boolean} true only when BOTH REACT_APP_NATIVE_CHAT and
 *     REACT_APP_NATIVE_BOTTOM_NAV_SHELL are exactly "true".
 */
export function isNativeChatFeatureEnabled() {
  return NATIVE_CHAT_FLAG_ENABLED && NATIVE_SHELL_FLAG_ENABLED;
}

// Exported individually only for the flag-matrix test - production code
// must always go through isNativeChatFeatureEnabled() above, never
// consult either flag independently.
export const __TEST_ONLY__ = {
  NATIVE_CHAT_FLAG_ENABLED,
  NATIVE_SHELL_FLAG_ENABLED,
};
